import { useEffect, useRef, useState } from "react"
import axios from 'axios'
import API, { baseURL } from "@api/api"
import { Spin, message, Input, Button } from "antd"
import Utils from '@utils/utils'
import styles from './index.module.scss'

export default function WechatScanForm (props) {
    const isMounted = useRef(true) // 判断组件是否已销毁
    const [loading, setLoading] = useState(false)
    const [wechatUrl, setWechatUrl] = useState()
    const sceneStrRef = useRef()
    const inviteCodeRef = useRef(String(sessionStorage.getItem('inviteCode') || ''))
    const [inviteCode, setinviteCode] = useState(String(sessionStorage.getItem('inviteCode') || ''))

    // 绑定手机号相关状态
    const [bindPhoneStep, setBindPhoneStep] = useState(false) // 是否进入绑定手机号步骤
    const [isNewUser, setIsNewUser] = useState(false) // 是否新用户
    const [loginData, setLoginData] = useState(null) // 暂存登录返回数据
    const [mobile, setMobile] = useState('')
    const [verifyCode, setVerifyCode] = useState('')
    const [waitCode, setWaitCode] = useState(false)
    const [countdown, setCountdown] = useState(60)
    const countdownRef = useRef(60)
    const [bindLoading, setBindLoading] = useState(false)
    const tempTokenRef = useRef(null) // 暂存临时token，不污染全局localStorage
    
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    // 扫码成功后检查用户手机号
    const handleScanSuccess = (data, isRegister) => {
        const tempToken = data.token
        tempTokenRef.current = tempToken

        axios.get(`${baseURL}/ps/web/user/userInfo`, {
            params: { ts: new Date().getTime() },
            headers: { 'Ps-Auth-Token': tempToken }
        }).then((res) => {
            const result = res.data
            if (result.code == 0 && result.data.mobile) {
                // 已有手机号，直接登录
                setTimeout(() => props.loginCallback(data), 500)
            } else {
                // 无手机号，进入绑定手机号步骤
                setLoginData(data)
                setIsNewUser(isRegister === true)
                setBindPhoneStep(true)
            }
        }).catch(() => {
            setTimeout(() => props.loginCallback(data), 500)
        })
    }



    const loopWechatStatus = () => {
        API.loginStatus({
            sceneStr: sceneStrRef.current,
            invitationCode: inviteCodeRef.current
        }).then(res => {
            if(res.code == 0) {
                handleScanSuccess(res.data, res.data.register)
            } else if(res.code == -5036) {
                if (!isMounted.current) return
                setTimeout(() => {
                    loopWechatStatus()
                }, 1000)
            } else if(res.code == -5035) {
                getWechatQrcode()
            } else {
                message.warning(res.message == '二维码已过期或不存在'?null: res.message)
                props.loginCallback()
            }
        })
    }
    const getWechatQrcode = () => {
        setLoading(true)
        API.wechatQrcode().then((res) => {
            if(res.code != 0) throw new Error(res.message)
            setWechatUrl(res.data.url)
            sceneStrRef.current = res.data.sceneStr
            loopWechatStatus()
        }).catch(err => {
            message.error(err.message)
        }).finally(() => {
            setLoading(false)
        })
    }
    useEffect(() => {
        getWechatQrcode()
    }, [])

    // 发送验证码
    const codeClick = () => {
        if (!Utils.validateContact(mobile)) {
            message.warning('请输入正确的手机号')
            return
        }
        if (!waitCode) {
            setWaitCode(true)
            axios.post(`${baseURL}/ps/web/user/sendCode`, {
                mobile: mobile,
                platform: sessionStorage.getItem('platform')
            }, {
                params: { ts: new Date().getTime() },
                headers: { 'Ps-Auth-Token': tempTokenRef.current }
            }).then((res) => {
                const result = res.data
                if (result.code == 0) {
                    message.success('发送成功！')
                    let id = setInterval(() => {
                        countdownRef.current -= 1
                        setCountdown(countdownRef.current)
                        if (countdownRef.current === 0) {
                            clearInterval(id)
                            setWaitCode(false)
                            countdownRef.current = 60
                            setCountdown(60)
                        }
                    }, 1000)
                } else {
                    setWaitCode(false)
                    message.error(result.message)
                }
            })
        }
    }

    // 绑定手机号并登录
    const handleBindAndLogin = () => {
        // 老用户可以不填手机号直接登录
        if (!isNewUser && !mobile) {
            props.loginCallback(loginData)
            return
        }

        // 新用户必须填写手机号和验证码
        if (isNewUser && (!mobile || !verifyCode)) {
            if (!mobile) message.warning('请输入手机号')
            else if (!verifyCode) message.warning('请输入验证码')
            return
        }

        // 有手机号时需要验证码
        if (mobile && !verifyCode) {
            message.warning('请输入验证码')
            return
        }

        if (mobile && !Utils.validateContact(mobile)) {
            message.warning('请输入正确的手机号')
            return
        }

        setBindLoading(true)
        // 微信新用户（register=true）先走 wechatRegister，拿返回 token 继续登录
        if (isNewUser) {
            API.wechatRegister({
                sceneStr: sceneStrRef.current,
                mobile,
                verifyCode,
            }).then((res) => {
                if (res?.code == 0 && res?.data?.token) {
                    const nextLoginData = {
                        ...(loginData || {}),
                        ...(res.data || {}),
                        token: res.data.token,
                        register: true,
                    }
                    tempTokenRef.current = res.data.token
                    props.loginCallback(nextLoginData)
                } else {
                    message.error(res?.message || '登录失败')
                }
            }).catch((err) => {
                message.error(err?.message || '登录失败')
            }).finally(() => {
                setBindLoading(false)
            })
            return
        }

        axios.post(`${baseURL}/ps/web/user/bindMobileOrCompany`, {
            mobile: mobile,
            verifyCode: verifyCode,
            platform: 'psai',
        }, {
            params: { ts: new Date().getTime() },
            headers: { 'Ps-Auth-Token': tempTokenRef.current }
        }).then(res => {
            const result = res.data
            if (result.code == 0) {
                props.loginCallback(loginData)
            } else {
                message.error(result.message)
            }
        }).catch(err => {
            message.error(err.message || '绑定失败')
        }).finally(() => {
            setBindLoading(false)
        })
    }

    // 绑定手机号界面
    if (bindPhoneStep) {
        return (
            <div className={`${styles.bindPhoneWrap} ${styles.Placeholder14Wrap}`}>
                <p className={styles.bindPhoneTitle}>
                    {isNewUser ? '还差一步，绑定手机号立即登录！' : '为了您的账号安全，请绑定手机号'}
                </p>
                <div className={styles.bindPhoneInput}>
                    <Input
                        size='large'
                        value={mobile}
                        placeholder="请输入手机号"
                        maxLength={11}
                        allowClear
                        onChange={(e) => setMobile(e.target.value)}
                        prefix={<img style={{width: 16}} src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/phoneIcon.svg" alt="" />}
                    />
                </div>
                <div className={styles.bindPhoneCode}>
                    <Input
                        size='large'
                        maxLength={6}
                        value={verifyCode}
                        placeholder="请输入验证码"
                        onChange={(e) => setVerifyCode(e.target.value)}
                        prefix={<img style={{width: 16}} src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/codeIcon.svg" alt="" />}
                        suffix={
                            <span className={styles.codeText} onClick={codeClick}>
                                {waitCode ? `${countdown}秒` : '获取验证码'}
                            </span>
                        }
                    />
                </div>
                <div className={styles.bindPhoneBtnWrap}>
                    <Button
                        type="primary"
                        size="large"
                        block
                        loading={bindLoading}
                        onClick={handleBindAndLogin}
                    >
                        登 录 / 注 册
                    </Button>
                </div>
                <p className={styles.bindPhoneTip}>* 未注册的手机号验证后将自动创建本产品账号</p>
            </div>
        )
    }

    // TODO: 临时mock按钮，测试完删除
    const mockLoginStatus = () => {
        const mockData = {
            channel: "wechat",
            email: "",
            mobile: "",
            nickname: "PSAI用户_pnjflu",
            noPassword: true,
            register: false,
            token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjUsInJuU3RyIjoiSjRUSWpiZzdOaE1kbEd0RWVwNkhkRHVtV0plMjBJNEoifQ.OC3SDOihz3kWgO5b5LMw4Xfu2-OSuabuubalHbh4BQw",
            userType: ""
        }
        handleScanSuccess(mockData, mockData.register)
    }

    return (
        <div className={styles.Placeholder14Wrap}>
            <Spin spinning={loading}>
                <div className={styles.wechatCode}>
                { wechatUrl && <img src={wechatUrl} alt="" /> }
                </div>
            </Spin>
            <Input
                style={{visibility: 'hidden'}}
                value={inviteCode}
                size="large"
                placeholder="邀请码（选填）"
                onChange={(e) => setinviteCode(e.target.value)}
                status=""
                prefix={<img style={{width: 16}} src={require('@assets/images/icon_Number.png')} alt="" />}
            />
            <p style={{marginTop: '6px', textAlign: 'center'}}>微信扫码关注公众号完成登录/注册</p>
            {/* TODO: 临时mock按钮，测试完删除 */}
            {/* <Button type="dashed" block style={{marginTop: 10}} onClick={mockLoginStatus}>Mock扫码(测试用)</Button> */}
        </div>
    )
}
